import React, { useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import { AvatarFromAws } from '../../components/avatarFromAws/AvatarFromAws';
import { borderInput } from '../../components/formAddress/formAddress.styles';
import { Header } from '../../components/header/Header';
import { Loader } from '../../components/loader/Loader';
import { ModalEditProfile } from '../../components/modals/editProfile/ModalEditProfile';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { getProfile } from '../../store/actions/actions';
import { capitalizeFirstLetter, convertedArrayReverseWithSpace } from '../../utils/methods';
import { useStyles } from './viewProfile.styles';

export const ViewProfile = (): JSX.Element => {
  const [editVisible, setEditVisible] = React.useState<boolean>(false);
  const loading = useAppSelector((state) => state.organizerReducer.loading);
  const profile = useAppSelector((state) => state.organizerReducer.profile);
  const classes = useStyles();
  const dispatch = useAppDispatch();

  useEffect(() => {
    getProfile()(dispatch);
  }, []);

  if (loading) {
    <Loader />;
  }

  return (
    <>
      <Header />
      {
        profile &&
        <div className={classes.mainBlock}>
          <Box className={classes.tabsBlock}>
            <div className={classes.mainTitle}>
              <Typography
                variant="h6"
                marginBottom="8px"
              >Organisation details
              </Typography>
            </div>
            <Button
              className={classes.createBtn}
              onClick={(): void => setEditVisible(true)}
            >EDIT PROFILE
            </Button>
          </Box>
          <Box>
            <AvatarFromAws photoKey={profile.photoUrl} className={classes.avatar} notPublic />
          </Box>
          <Box className={classes.formWrapper} component="form">
            <Box className={classes.formTop}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  label="Organisation name"
                  value={profile.name}
                  defaultValue={profile.name}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Contact name"
                  value={profile.contactName}
                  defaultValue={profile.contactName}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Email"
                  value={profile.email}
                  defaultValue={profile.email}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Phone number"
                  value={profile.phoneNumber}
                  defaultValue={profile.phoneNumber}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Address"
                  value={profile.address}
                  defaultValue={profile.address}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Website link"
                  value={profile.websiteUrl}
                  defaultValue={profile.websiteUrl}
                  focused
                  sx={{ caretColor: 'transparent', cursor: 'default' }}
                />
              </FormControl>
            </Box>
            <FormControl fullWidth={true}>
              <TextField
                id="outlined-basic"
                label="Categories"
                value={capitalizeFirstLetter(profile.category)}
                defaultValue={capitalizeFirstLetter(profile.category)}
                focused
                sx={{ caretColor: 'transparent', cursor: 'default' }}
              />
            </FormControl>
            <FormControl fullWidth={true}>
              <TextField
                id="outlined-basic"
                label="Sustainable Development Goals"
                value={convertedArrayReverseWithSpace(profile.sustainableGoals)}
                defaultValue={convertedArrayReverseWithSpace(profile.sustainableGoals)}
                focused
                sx={{ caretColor: 'transparent', cursor: 'default' }}
              />
            </FormControl>
            <FormControl fullWidth={true}>
              <TextField
                id="outlined-basic"
                label="Description"
                multiline
                rows={4}
                value={profile.description}
                defaultValue={profile.description}
                focused
                sx={{ caretColor: 'transparent', cursor: 'default' }}
              />
            </FormControl>
          </Box>
        </div>
      }
      <ModalEditProfile open={editVisible} setOpen={setEditVisible} />
    </>
  );
};
